angular.module('PatientApp').controller('LoyalCtrl', function($rootScope, $window, $state, $scope, $q, $log, $filter, _, ReasonsService, PatientUsersService, BillsService, ProvidersService, LiveChatService) {
    $window.GuideSDKInit = function() {

        $window.GuideSDK.on('conversationStart', function(conversation) {
            $rootScope.chatSessionActive = true;
            _assignMinimizeButton();

            LiveChatService.postConversation(conversation.conversationId);
        });

        _updateUserInfo();

        $rootScope.$on('user:changed', function() {
            _updateUserInfo();
        });

        $rootScope.$on('data:clear', function() {
            _resetWidget();
        });
    };

    $window.loyalActions = {
        deepLinks: {
            logIn: function() {
                $rootScope.$emit('contact:show', {subject: 'Logging In', state: 'zendesk'});
                _minimizeMobile();
            },
            forgotPassword: function() {
                var deferred = $q.defer();
                $rootScope.$emit('login:showPrompt', deferred, { openSection: 'forgotpassword' });
                _minimizeMobile();
            },
            changePassword: function() {
                $state.go('app.settings.accountManagement');
                _minimizeMobile();
            },
            technicalIssue: function() {
                $rootScope.$emit('contact:show', {subject: 'Live Chat Technical Issue', state: 'zendesk'});
                _minimizeMobile();
            },
            itemizedReceipt: function() {
                var data = {
                    reason: ReasonsService.getReasonByCode('itemizedBill').id
                };

                var currentBill = BillsService.getCurrentBill();
                if (currentBill !== null) {
                    data.useCurrentBill = true;
                }

                $rootScope.$emit('message:compose', data);
                _minimizeMobile();
            },
            updateInformation: function() {
                var currentUser = PatientUsersService.getCurrentUser();
                var data = {
                    reason: ReasonsService.getReasonByCode('updateInsurance').id
                };

                if(currentUser !== null) {
                    var currentBill = BillsService.getCurrentBill();
                    if(currentBill !== null) {
                        data.useCurrentBill = true;
                    }
                    $rootScope.$emit('message:compose', data);
                } else {
                    data.state = 'bill';
                    $rootScope.$emit('contact:show', data);
                }
                _minimizeMobile();
            },
            paymentForms: function() {
                $state.go('app.settings.savedPaymentMethods');
                _minimizeMobile();
            },
            paymentPlans: function() {
                _getProviders();
                _minimizeMobile();
            }
        }
    };

    var _isMobile = /(phone|mobile)/i.test(navigator.userAgent),
        _minimizeButton = null,
        _updateUserInfo = function() {
            var user = PatientUsersService.getCurrentUser();

            if(user) {
                $window.GuideSDK.bot.setCustomVariables({
                    custom_first_name: user.firstName,
                    custom_last_name: user.lastName,
                    custom_phone_number: user.phoneNumberConfirmed ? user.phoneNumber : null,
                    custom_email_address: user.emailVerified ? user.email : null,
                    custom_patient_id: '' + user.patientUserId
                });
            }
        },
        _init = function() {
            var guide = $window.document.createElement('script');
            guide.id = 'guide-loader';
            guide.type = 'text/javascript';
            guide.async = true;
            guide.src = 'https://guide.loyalhealth.com/client/client.bundle.js';
            guide.dataset.id = 'guide-client-id';
            guide.dataset.value = $scope.clientId;

            var body = $window.document.getElementsByTagName('body')[0];
            body.appendChild(guide);
        },
        _resetWidget = function() {
            //remove elements added by Loyal
            var guide = $window.document.getElementById('guide-loader');
            guide.parentNode.removeChild(guide);
            guide = $window.document.getElementById('guide');
            guide.parentNode.removeChild(guide);

            //remove loaded SDK
            $window.GuideSDK = undefined;

            //remove session variables storing chat info
            $window.sessionStorage.removeItem('persist:root');
            $window.sessionStorage.removeItem('conversationId');

            //reinitialize the widget
            _init();
        },
        _getProviders = function() {
            ProvidersService.getProviders().then(function(providers) {

                $scope.noProviders = false;

                if (providers.length === 0) {
                    $scope.noProviders = true;
                    $scope.showModal = true;
                } else if (providers.length === 1) {
                    $scope.selectedProvider = providers[0];
                    $scope.providerId = providers[0].id;
                    _getAccounts();
                } else {
                    $scope.providers = providers;
                    $scope.askForProvider = true;
                    $scope.showModal = true;
                }
            });
        },
        _getAccounts = function() {
            if($scope.selectedProvider === null){
                $log.error('No providers to fetch payment plan options');
                return;
            }

            var accountsLen = $scope.selectedProvider.accounts.length;

            if(accountsLen === 1){
                $scope.secureCode = $scope.selectedProvider.accounts[0].secureCode;
                _goToPaymentPlans();
            }else {
                _.forEach($scope.selectedProvider.accounts, function(acc){
                    acc.friendlyAccountBalance = $filter('translate')( 'labels.argBalance', {balance: $filter('currency')(acc.amountDue)} );
                });

                $scope.askForAccount = true;
                $scope.accounts = $scope.selectedProvider.accounts;
                $scope.showModal = true;
            }
        },
        _goToPaymentPlans = function() {
            $scope.resetModal();
            //have to trigger a reload here in case they were already in the payment flow and chose a different account
            $state.go('app.payment.start', {secureCode: $scope.secureCode, goto: 'plans'}, {reload: true});
        },
        _assignMinimizeButton = function() {
            var guide = document.getElementById('guide');
            if(guide) {
                var shadowRoot = guide.shadowRoot;
                if(shadowRoot) {
                    var minimize = shadowRoot.querySelector('button[data-testref=header-right-button]');
                    if(minimize) {
                        _minimizeButton = minimize;
                    }
                }
            }

            return null;
        },
        _minimizeMobile = function() {
            if(_isMobile) {
                if(!_minimizeButton) {
                    _assignMinimizeButton();
                }

                if(_minimizeButton) {
                    _minimizeButton.click();
                }
            }
        };

    $scope.selectProvider = function(id){
        $scope.selectedProvider = _.find($scope.providers, function(provider){
            return provider.id === id;
        });
        $scope.askForProvider = false;
        _getAccounts();
    };

    $scope.selectAccount = function(id){
        var selectedAccount = _.first(_.filter($scope.selectedProvider.accounts || [], function(account){
            return account.accountId === id;
        }));
        $scope.secureCode = selectedAccount.secureCode;

        _goToPaymentPlans();
    };

    $scope.resetModal = function() {
        $scope.showModal = false;
        $scope.providers = [];
        $scope.selectedProvider = null;
        $scope.askForProvider = false;
        $scope.askForAccount = false;
    };

    $scope.resetModal();
    _init();
});
